import React from 'react';
import CalendarComponent from './calendar/CalendarComponent';
import { OccPayload } from '../../pms-calendar/lib/OccPayload';
import { ResourcePayload } from '../../pms-calendar/lib/ResourcesPayload';
import { EventsPayload } from '../../pms-calendar/lib/EventsPayload';

interface RoomMaintenanceCalendarProps {
    todayDate: string;
    date30DaysFromNow: string;
    setTodayDate: (date: string) => void;
    setDate30DaysFromNow: (date: string) => void;
    occupancyPayload: OccPayload[];
    resourcesPayload: ResourcePayload[];
    eventsPayload: EventsPayload[];
    onCreateFromDrag: (startDate: string, endDate: string, roomTypeId: string, roomId: string) => void;
    onEditRoomMaintenance: (id: string) => void;
    isReadOnly?: boolean;
}

const RoomMaintenanceCalendar: React.FC<RoomMaintenanceCalendarProps> = ({
    todayDate,
    date30DaysFromNow,
    setTodayDate,
    setDate30DaysFromNow,
    occupancyPayload,
    resourcesPayload,
    eventsPayload,
    onCreateFromDrag,
    onEditRoomMaintenance,
    isReadOnly = false,
}) => {
    return (
        <>
            <CalendarComponent
                startDate={todayDate}
                endDate={date30DaysFromNow}
                setStartDate={setTodayDate}
                setEndDate={setDate30DaysFromNow}
                occupancy={occupancyPayload}
                resourcesPayload={resourcesPayload}
                eventsPayload={eventsPayload}
                onCreateFromDrag={onCreateFromDrag}
                onEditRoomMaintenance={onEditRoomMaintenance}
                isReadOnly={isReadOnly}
            />

        </>
    )
}

export default RoomMaintenanceCalendar